import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, Grid, TextField, Button, Box } from "@mui/material";
import dayjs from "dayjs";
import { RowResponseType } from "@/types/view"; // your type
import { AttachFile } from "@mui/icons-material";
import { STATUS_REQUEST } from "@/const/system.const";
import { getLabel } from "@/language";

interface DialogDetailResponseProps {
  open: boolean;
  data: RowResponseType | null;
  onClose: () => void;
  onReject: () => void;
  onAccept: () => void;
}

const DialogDetailResponse: React.FC<DialogDetailResponseProps> = ({ open, data, onClose, onReject, onAccept }) => {
  if (!data) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Phản hồi truy vấn</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} mt={2}>
          <Grid item xs={12}>
            <TextField
              label="ID Truy vấn"
              fullWidth
              value={data.transferResponseUid || ""}
              InputProps={{ readOnly: true }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Hệ thống truy vấn"
              fullWidth
              value={data.applicationSendName || ""}
              InputProps={{ readOnly: true }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Thời gian tạo mới"
              fullWidth
              value={data.requestCreated ? dayjs(data.requestCreated).format("DD/MM/YYYY HH:mm:ss") : ""}
              InputProps={{ readOnly: true }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Thời gian phản hồi"
              fullWidth
              value={data.responseCreated ? dayjs(data.responseCreated).format("DD/MM/YYYY HH:mm:ss") : ""}
              InputProps={{ readOnly: true }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Trạng thái truy vấn"
              fullWidth
              value={getLabel("OBJ_STATUS_REQUEST." + STATUS_REQUEST[data.requestStatus])}
              InputProps={{ readOnly: true }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Trạng thái phản hồi"
              fullWidth
              value={getLabel("OBJ_STATUS_REQUEST." + STATUS_REQUEST[data.requestStatus])}
              InputProps={{ readOnly: true }}
            />
          </Grid>

          <Grid item xs={12}>
            <Box style={{ display: "flex", border: "1px solid #d4cfcf", alignItems: "center", height: "56px" }}>
              <AttachFile />
              <Button>file.zip</Button>
            </Box>
          </Grid>
        </Grid>
        <Grid container spacing={2} marginTop={2} justifyContent="flex-end">
          {data.requestStatus == STATUS_REQUEST.success && (
            <>
              <Grid item>
                <Button variant="contained" color="error" onClick={onReject}>
                  Từ chối
                </Button>
              </Grid>
              <Grid item>
                <Button variant="contained" color="primary" onClick={onAccept}>
                  Đồng ý
                </Button>
              </Grid>
            </>
          )}
          <Grid item>
            <Button variant="outlined" color="primary" onClick={onClose}>
              Đóng
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default DialogDetailResponse;
